import React from 'react';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Title from 'shared/components/title/Title';
import confirmDiscardChanges from 'shared/components/confirm-discard-changes/confirmDiscardChanges';
import Loader from 'features/Loader/Loader';
import { getClients } from 'features/home/ducks/clientActions';
import WorkoutAssignList from './WorkoutAssignList';
import { getWorkout, assignWorkoutToClients } from '../../ducks/workoutActions';

class WorkoutClientAssign extends React.Component {
  constructor(props) {
    super(props);
    this.workoutId = props.match.params.id;
  }
  componentDidMount() {
    this.props.getWorkout(this.workoutId, this.props.history);
    this.props.getClients();
  }

  render() {
    let {
      clients,
      workout,
      history,
      loadingWorkout,
      clientLoadingState
    } = this.props;
    let { clients_id } = workout;

    let unassignedClients = [];
    clients &&
      clients.forEach(client => {
        if (!(clients_id || []).includes(client.id)) {
          unassignedClients.push(client);
        }
      });

    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          clients_id: []
        }}
        onSubmit={values => {
          let selectedClients =
            clients &&
            clients.filter(client => values.clients_id.includes(client.id));
          return (
            workout &&
            values.clients_id.length &&
            this.props.assignWorkoutToClients(
              selectedClients,
              workout.id,
              history
            )
          );
        }}
      >
        {formik => (
          <Form>
            {formik.isSubmitting || loadingWorkout || clientLoadingState ? (
              <Loader />
            ) : (
              <div className="workout assign-client">
                <div className="container">
                  <Breadcrumb>
                    <Breadcrumb.Item href="/workouts">Workouts</Breadcrumb.Item>
                    <Breadcrumb.Item href={`/workouts/${this.workoutId}`}>
                      {workout && workout.name}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Assign Client</Breadcrumb.Item>
                  </Breadcrumb>
                  <Title
                    pageTitle="Assign Client"
                    buttonText={unassignedClients.length > 0 && 'Save'}
                    linkText="Cancel"
                    cancelLink={`/workouts/${this.workoutId}`}
                    cancelBtn={
                      formik.dirty &&
                      (() =>
                        confirmDiscardChanges(
                          `/workouts/${this.workoutId}`,
                          history
                        ))
                    }
                    disabled={!formik.values.clients_id.length}
                  />
                  <WorkoutAssignList unassignedClients={unassignedClients} />
                </div>
              </div>
            )}
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    workout: state.workoutReducer.workout,
    loadingWorkout: state.workoutReducer.loading,
    clients: state.clientReducer.clients,
    clientLoadingState: state.clientReducer.loadingState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getWorkout: (workoutId, history) =>
      dispatch(getWorkout(workoutId, history)),
    getClients: () => dispatch(getClients()),
    assignWorkoutToClients: (clients, workoutId, history) =>
      dispatch(assignWorkoutToClients(clients, workoutId, history))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkoutClientAssign);
